import { useEffect, useState } from "react";
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from "@mui/material";
import UserCROServiceRegistrationForm from "../components/UserCROServiceRegistrationForm";

export default function CompanyCROServiceRegisteration() {
    const [compId, setCompId] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get("compId");
        setCompId(id);
    }, [location.search]);

    const queryParams = new URLSearchParams(location.search);
    const compName = queryParams.get("compName");
    const typesParam = queryParams.get("types");
    const companyTypes = typesParam ? typesParam.split(",") : [];

    return (
        <Wrapper className="container">
            {/* BreadCrumbs */}
            <Breadcrumbs aria-label="breadcrumb" className='mb-5 mt-2 pageBreadCrumbs'>
                <Link color="inherit" href="/user-companies"> Companies </Link>
                <Link color="inherit" href={`/user-company-details?compId=${compId}`}> {compName} </Link>
                <Typography sx={{ color: 'text.primary' }}> Add CRO (Contract Registraion Organisation) Service </Typography>
            </Breadcrumbs>

            <h2 className="pageTitle after_title_line"> Register your CRO Service </h2>
            <p className="statusBox"> Register CRO Service for <strong>{compName}</strong> </p>

            {compId && (
                <UserCROServiceRegistrationForm
                    compId={compId}
                    compName={compName}
                    companyTypes={companyTypes}
                />
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
.statusBox {
    background: var(--bg-color);
    border-left: 6px solid var(--secondary-color);
    padding: 4px 10px;
    color: var(--primary-color);
    margin-bottom: 20px;
}
`;
